import { render, staticRenderFns } from "./MyTowerCard.vue?vue&type=template&id=7610655e&scoped=true&"
import script from "./MyTowerCard.vue?vue&type=script&lang=js&"
export * from "./MyTowerCard.vue?vue&type=script&lang=js&"
import style0 from "./MyTowerCard.vue?vue&type=style&index=0&id=7610655e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7610655e",
  null
  
)

export default component.exports